export default {"src":"/_next/static/media/apk-qr-primexbt-one.3d42185e.svg","height":225,"width":225,"blurWidth":0,"blurHeight":0};